export default __webpack_public_path__ + "static/media/100_39305.43ccff0a.jpg";